import { useCallback } from 'react';

import { useGlobalHotKey } from 'containers/GlobalHotKeys';
import useSetThemeKey from 'hooks/useSetThemeKey';
import useThemeMode from 'hooks/useThemeMode';

const AppearanceHotKeys = () => {
  const setThemeKey = useSetThemeKey();
  const themeMode = useThemeMode();

  // Flips what is on screen, which before the preferences load is the saved or system appearance.
  const onToggleAppearanceMode = useCallback(() => {
    setThemeKey(themeMode === 'dark' ? 'muiDefault' : 'ACME_DARK');
  }, [setThemeKey, themeMode]);
  useGlobalHotKey({
    description: 'Toggle Light/Dark Mode Appearance',
    shiftKey: true,
    altKey: true,
    code: 'KeyA',
    callback: onToggleAppearanceMode,
  });

  return null;
};
export default AppearanceHotKeys;
